/**
 * Country constants for internationalization
 * Uses ISO 3166-1 numeric codes
 */

// Country IDs (ISO 3166-1 numeric)
export const COUNTRY_US = 840;
export const COUNTRY_CANADA = 124;
export const COUNTRY_UK = 826;
export const COUNTRY_IRELAND = 372;

// Country metadata
export const COUNTRIES = {
    [COUNTRY_US]: {
        id: COUNTRY_US,
        name: 'United States',
        code: 'US',
        currency: 'USD',
        locale: 'en-US',
        dateFormat: 'us', // Month first (January 5)
        useMetric: false,
        postalCodeLabel: 'ZIP Code',
        regionLabel: 'State',
    },
    [COUNTRY_CANADA]: {
        id: COUNTRY_CANADA,
        name: 'Canada',
        code: 'CA',
        currency: 'CAD',
        locale: 'en-CA',
        dateFormat: 'us',
        useMetric: true,
        postalCodeLabel: 'Postal Code',
        regionLabel: 'Province',
    },
    [COUNTRY_UK]: {
        id: COUNTRY_UK,
        name: 'United Kingdom',
        code: 'GB',
        currency: 'GBP',
        locale: 'en-GB',
        dateFormat: 'uk', // Day first (5 January)
        useMetric: true,
        postalCodeLabel: 'Postcode',
        regionLabel: 'Region',
    },
    [COUNTRY_IRELAND]: {
        id: COUNTRY_IRELAND,
        name: 'Ireland',
        code: 'IE',
        currency: 'EUR',
        locale: 'en-IE',
        dateFormat: 'uk', // Day first
        useMetric: true,
        postalCodeLabel: 'Eircode',
        regionLabel: 'County',
    },
};

/**
 * Get country metadata by ID
 * @param {number} countryId - ISO country code
 * @returns {object} - Country metadata or US as default
 */
export const getCountry = (countryId) => {
    return COUNTRIES[countryId] || COUNTRIES[COUNTRY_US];
};

/**
 * Check if country uses day-first date format
 * @param {number} countryId - ISO country code
 * @returns {boolean}
 */
export const useDayFirstDate = (countryId) => {
    const country = getCountry(countryId);
    return country.dateFormat === 'uk';
};

/**
 * Check if country is UK or Ireland (for UK/IE specific fields)
 * @param {number} countryId - ISO country code
 * @returns {boolean}
 */
export const isUKOrIreland = (countryId) => {
    return countryId === COUNTRY_UK || countryId === COUNTRY_IRELAND;
};

/**
 * Check if country is UK (for UK-only fields like EPC, Council Tax)
 * @param {number} countryId - ISO country code
 * @returns {boolean}
 */
export const isUK = (countryId) => {
    return countryId === COUNTRY_UK;
};

/**
 * Check if country is Ireland (for Ireland-only fields like BER, Eircode)
 * @param {number} countryId - ISO country code
 * @returns {boolean}
 */
export const isIreland = (countryId) => {
    return countryId === COUNTRY_IRELAND;
};
